import { defineStore } from 'pinia';
import type { BillingDetailsState } from '~~/types/vuex/BillingDetails';

export const billingDetailsStore = defineStore('billingDetails', {
  state: (): { billingDetails: BillingDetailsState['billingDetails'] } => ({ billingDetails: {} }),
  actions: {
    setBillingDetails(payload: BillingDetailsState['billingDetails']) {

      this.billingDetails = payload; 

    },
  },
});
